import type { Screen } from '../types';

export const UPDATE_BLOCKED_SCREENS: Screen[] = ['scoreInput', 'selectCourse'];

export function canApplyAppUpdate(screen: Screen) {
  return !UPDATE_BLOCKED_SCREENS.includes(screen);
}

export function isBuildOutdated(runningBuildId?: string | null, remoteBuildId?: string | null) {
  if (!runningBuildId || !remoteBuildId || runningBuildId === 'dev') {
    return false;
  }
  return runningBuildId !== remoteBuildId;
}
